import Intercom, { boot, shutdown, update, show, hide } from "@intercom/messenger-js-sdk";
import React, { useEffect, useRef } from "react";
import { cqAPI } from "./lib/Auth";

export default function IntercomMessenger({
  user,
  business
}) {
  const lastUserId = useRef(null)
  const lastBusinessId = useRef(null)
  const loadedOnce = useRef(null)

  useEffect(() => {
    if (user && business?.bid && !user.isSuperAdmin && !user.isPatient && (!business?.partner || business?.partner?.intercom)) {
      if (loadedOnce.current){
        cqAPI.get('/intercom-token').then(data=>{
          boot({
            app_id: process.env.REACT_APP_INTERCOM_APPID,
            vertical_padding: 80,
            user_id: user.id,
            name: user.name,
            email: user.email,
            created_at: user.createdAt,
            company: {
              id: business.bid,
              name: business.name,
            },
            intercom_user_jwt : data.data
          });
        })
      }else{
        cqAPI.get('/intercom-token').then(data=>{
          Intercom({
            app_id: process.env.REACT_APP_INTERCOM_APPID,
            user_id: String(user.id),
            vertical_padding: 80,
            name: user.name,
            email: user.email,
            created_at: user.createdAt,
            company: {
              id: business.bid,
              name: business.name,
            },
            intercom_user_jwt : data.data
          });
          loadedOnce.current = true;
        })
        
      }
      lastUserId.current = user.id;
      lastBusinessId.current = business.bid
    } else if (lastUserId.current && (!user?.id || !business?.bid)){
      shutdown("shutdown");
      lastUserId.current = user?.id;
      lastBusinessId.current = business?.bid;
    }else if (lastBusinessId.current && business?.bid && (lastBusinessId.current !== business?.bid) && (lastUserId.current === user?.id)){
      update('update', {
        company: {
          id: business.bid,
          name: business.name,
        }
      });
    }
  }, [user, business]);

  return null; // nothing to render
}